import React, { useState, useEffect } from 'react';
import './LandingPage.css';
import BackgroundCanvas from './components/BackgroundCanvas';
import ConsumerGlobe from './components/ConsumerGlobe';
const SHEETS_URL = 'https://script.google.com/macros/s/AKfycbw1quIU2HjEwLOBodUTfSldYAk7e-kUy-TXngGbCREOuP8VvG8dZll1V_K1CBj_LmbJ/exec';

const TAG_SETS = [
  {
    tags: [
      { label: 'Gen Z', active: true },
      { label: 'Mumbai', active: true },
      { label: 'Millennial', active: false },
      { label: 'Beauty', active: true },
      { label: 'Delhi', active: false },
      { label: 'Skincare', active: true },
    ],
    population: 78400,
    barWidth: '78%',
  },
  {
    tags: [
      { label: 'Millennial', active: true },
      { label: 'Bangalore', active: true },
      { label: 'Gen X', active: false },
      { label: 'Fashion', active: true },
      { label: 'Pune', active: false },
      { label: 'FMCG', active: true },
    ],
    population: 52100,
    barWidth: '52%',
  },
  {
    tags: [
      { label: 'Gen X', active: false },
      { label: 'Chennai', active: true },
      { label: 'Gen Z', active: true },
      { label: 'Electronics', active: true },
      { label: 'Hyderabad', active: true },
      { label: 'Wellness', active: false },
    ],
    population: 63800,
    barWidth: '64%',
  },
  {
    tags: [
      { label: 'Gen Z', active: true },
      { label: 'Jaipur', active: false },
      { label: 'Millennial', active: true },
      { label: 'Food & Bev', active: true },
      { label: 'Kolkata', active: true },
      { label: 'Apparel', active: false },
    ],
    population: 91200,
    barWidth: '91%',
  },
];

const DefineCard = () => {
  const [currentSet, setCurrentSet] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setCurrentSet((prev) => (prev + 1) % TAG_SETS.length);
        setFading(false);
      }, 400);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const set = TAG_SETS[currentSet];

  return (
    <div className="hiw-card hiw-card--orange fu">
      <div className="hiw-card-header">
        <div className="hiw-card-header-left">
          <div className="hiw-card-label" style={{ color: '#F26E38' }}>DEFINE</div>
          <div className="hiw-card-stage">STAGE_01</div>
        </div>
        <div className="hiw-card-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.6)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/><path d="M12 8v8"/><path d="M8 12h8"/>
          </svg>
        </div>
      </div>
      <div className="hiw-card-body">
        <h3>Define Your Audience</h3>
        <p>Describe your target consumer — demographics, location, psychographics, purchase habits. SocietyX builds a digital twin population that mirrors your real market.</p>
      </div>
      <div className="hiw-card-demo">
        <div className={`hiw-tags-animated ${fading ? 'fade-out' : 'fade-in'}`}>
          <div className="hiw-demo-chips">
            {set.tags.slice(0, 3).map((tag, i) => (
              <span key={i} className={`hiw-chip ${tag.active ? 'on' : ''}`}>{tag.label}</span>
            ))}
          </div>
          <div className="hiw-demo-chips">
            {set.tags.slice(3, 6).map((tag, i) => (
              <span key={i} className={`hiw-chip ${tag.active ? 'on' : ''}`}>{tag.label}</span>
            ))}
          </div>
        </div>
        <div className={`hiw-pop-bar ${fading ? 'fade-out' : 'fade-in'}`}>
          <div className="hiw-pop-label">Population Size</div>
          <div className="hiw-pop-track">
            <div className="hiw-pop-fill" style={{ width: set.barWidth }}></div>
          </div>
          <div className="hiw-pop-val">{set.population.toLocaleString()}</div>
        </div>
      </div>
      <div className="hiw-card-footer">
        <div className="hiw-dots">
          <span className="hiw-dot active"></span>
          <span className="hiw-dot"></span>
          <span className="hiw-dot"></span>
        </div>
      </div>
    </div>
  );
};

const LandingPage = () => {
  const [emailHero, setEmailHero] = useState('');
  const [emailFooter, setEmailFooter] = useState('');
  const [successHero, setSuccessHero] = useState(false);
  const [successFooter, setSuccessFooter] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState(-1);
  const [showModal, setShowModal] = useState(false);
  const [modalName, setModalName] = useState('');
  const [modalEmail, setModalEmail] = useState('');
  const [modalProblem, setModalProblem] = useState('');
  const [modalSuccess, setModalSuccess] = useState(false);
  const [modalSubmitting, setModalSubmitting] = useState(false);

  const [showTeamModal, setShowTeamModal] = useState(false);
  const [teamName, setTeamName] = useState('');
  const [teamLinkedIn, setTeamLinkedIn] = useState('');
  const [teamPhone, setTeamPhone] = useState('');
  const [teamSuccess, setTeamSuccess] = useState(false);
  const [teamSubmitting, setTeamSubmitting] = useState(false);

  // Scroll animations
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('vis');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.fu').forEach((el) => obs.observe(el));

    return () => obs.disconnect();
  }, []);

  const openModal = (prefillEmail = '') => {
    setModalEmail(prefillEmail);
    setModalSuccess(false);
    setModalName('');
    setModalProblem('');
    setShowModal(true);
  };

  const handleModalSubmit = async () => {
    if (!modalEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(modalEmail)) return;
    if (modalSubmitting) return;
    setModalSubmitting(true);
    try {
      await fetch(SHEETS_URL, {
        method: 'POST',
        body: JSON.stringify({ name: modalName, email: modalEmail, problem: modalProblem, source: 'modal' }),
      });
      setModalSuccess(true);
    } catch (error) {
      console.error('Error joining waitlist:', error);
    } finally {
      setModalSubmitting(false);
    }
  };

  const handleTeamSubmit = async () => {
    if (!teamName.trim() || !teamLinkedIn.trim()) return;
    if (teamSubmitting) return;
    setTeamSubmitting(true);
    try {
      await fetch(SHEETS_URL, {
        method: 'POST',
        body: JSON.stringify({ name: teamName, linkedin: teamLinkedIn, phone: teamPhone, source: 'join_team' }),
      });
      setTeamSuccess(true);
    } catch (error) {
      console.error('Error submitting team application:', error);
    } finally {
      setTeamSubmitting(false);
    }
  };

  const joinWaitlist = async (section) => {
    const email = section === 'hero' ? emailHero : emailFooter;
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return;
    }
    openModal(email);
  };

  const handleKeyDown = (e, section) => {
    if (e.key === 'Enter') {
      joinWaitlist(section);
    }
  };

  const toggleFaq = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? -1 : index);
  };

  const faqData = [
    {
      q: 'How accurate are the simulations?',
      a: "SocietyX's consumer agents are trained on real behavioural data — purchase patterns, social signals, and economic models. In backtests, our simulations predict real-world purchase intent with over 80% directional accuracy."
    },
    {
      q: 'Do I need technical knowledge?',
      a: 'Not at all. SocietyX is built for brand managers, founders, and marketers — not data scientists. Describe your product in plain language and we handle everything else.'
    },
    {
      q: 'How is this different from surveys?',
      a: "Surveys tell you what people say they'll do. SocietyX simulates what they actually do. Our AI consumers don't suffer from social desirability bias — they behave based on real purchase psychology, at scale, in minutes."
    },
    {
      q: 'What products work best with SocietyX?',
      a: 'Any consumer-facing product — FMCG, beauty, fashion, food & beverage, electronics. If it\'s sold to end consumers, SocietyX can simulate the market for it.'
    },
    {
      q: 'When will SocietyX launch?',
      a: "We're in private beta with select D2C brands. Join the waitlist and we'll reach out personally when we're ready to onboard your team."
    }
  ];

  return (
    <div className="landing-page">
      <BackgroundCanvas />
      
      {/* NAV */}
      <nav>
        <div className="logo">SocietyX</div>
        <ul className="nav-links">
          <li><a href="#use-cases">Use Cases</a></li>
          <li><a href="#how-it-works">How It Works</a></li>
          <li><a href="#faq">FAQ</a></li>
        </ul>
        <div className="nav-right">
          <button className="btn-orange nav-cta" data-testid="join-waitlist-nav" onClick={() => openModal()}>
            Join Waitlist
          </button>
          <button className="btn-orange mobile-nav-waitlist" onClick={() => openModal()}>
            Join Waitlist
          </button>
        </div>
      </nav>

      {/* HERO */}
      <div className="hero-bg" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/Try4.gif)` }}>
      <section className="hero">
        <div className="hero-left">
          <div className="hero-badge">
            <span className="badge-dot"></span> Early Access Open
          </div>

          <h1>
            Consumer Behavior,<br />
            <span className="orange">Predicted.</span>
          </h1>

          <p className="hero-sub">
            Millions of AI consumers that <span className="orange">buy, skip, and scroll</span> before you go to market.
          </p>

          <div className="waitlist-row" id="waitlist-hero">
            <input
              id="email-hero"
              type="email"
              value={emailHero}
              onChange={(e) => setEmailHero(e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, 'hero')}
              placeholder="you@yourbrand.com"
              disabled={successHero}
            />
            <button className="btn-orange" onClick={() => joinWaitlist('hero')}>
              Get Early Access
            </button>
          </div>
          {successHero && (
            <div className="success-msg">
              ✓ You're on the list — we'll be in touch soon.
            </div>
          )}
        </div>

      </section>
      </div>

      {/* STATS */}
      <div className="stats-section">
        <div className="stats-grid">
          <div className="stat-cell fu">
            <div className="stat-num">
              85<span className="stat-pct">%</span>
            </div>
            <div className="stat-desc">
              of new consumer products fail in their first year. Most could have been{' '}
              <strong className="stat-highlight">
                predicted and avoided.
                <svg className="highlight-arc" viewBox="0 0 200 8" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                  <path d="M2,6 Q100,1 198,6" stroke="var(--orange)" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
                </svg>
              </strong>
            </div>
          </div>
          <div className="stat-cell fu">
            <div className="stat-num stat-num--inline">
              $0
              <span className="stat-sublabel">wasted on wrong bets</span>
            </div>
            <div className="stat-desc">
              Get clarity on which ideas won't work before you fund them. The most valuable insight{' '}
              <strong className="stat-outline">Isn't what to build — it's <s>what</s> NOT to.</strong>
            </div>
          </div>
          <div className="stat-cell fu">
            <div className="stat-num">
              24<span> hrs</span>
            </div>
            <div className="stat-desc">
              from product brief to full consumer simulation results. <span className="stat-handwritten">Not weeks — <span className="orange">hours.</span></span>
            </div>
          </div>
        </div>
      </div>

      {/* BENTO / FEATURES */}
      <section className="bento-section" id="use-cases">
        <div className="fu">
          <div className="section-label">What SocietyX does</div>
          <h2 className="section-title">From product idea to consumer truth.</h2>
        </div>

        <div className="bento-grid">
          {/* Row 1: Audience Builder + Globe */}
          <div className="bc bc-combined fu">
            <div className="bc-combined-left">
              <div>
                <div className="bc-label">Audience Builder</div>
                <h3>Build your target consumer society</h3>
                <p style={{ marginTop: '32px' }}>
                  Define demographics, psychographics, and purchase habits. SocietyX mirrors your
                  real market at any scale.
                </p>
              </div>
              <div className="pb-chips-group">
                <div className="pb-row">
                  <span className="pb-chip on">Gen Z</span>
                  <span className="pb-chip">Millennial</span>
                  <span className="pb-chip">Gen X</span>
                </div>
                <div className="pb-row">
                  <span className="pb-chip on">Mumbai</span>
                  <span className="pb-chip on">Delhi</span>
                  <span className="pb-chip">Bangalore</span>
                  <span className="pb-chip">Tier 2</span>
                </div>
                <div className="pb-row">
                  <span className="pb-chip on">Beauty</span>
                  <span className="pb-chip">Fashion</span>
                  <span className="pb-chip on">Skincare</span>
                  <span className="pb-chip">FMCG</span>
                </div>
              </div>
            </div>
            <div className="bc-combined-right">
              <ConsumerGlobe />
              <div className="bc-globe-label">1.5Mn+ consumer profiles</div>
            </div>
          </div>

          {/* Row 2: Segment Insights + Pricing Strategy */}
          <div className="bc bc-text fu">
            <div>
              <div className="bc-label">Segment Insights</div>
              <h3>Know exactly who wants it</h3>
              <p>
                Purchase intent broken down by cohort, segment, and geography.
              </p>
            </div>
            <div className="bc-visual-demo">
              <div className="mini-bars">
                <div className="mb-row">
                  <div className="mb-label">
                    <span>Gen Z (18–24)</span>
                    <span className="mb-val">82%</span>
                  </div>
                  <div className="mb-track">
                    <div className="mb-fill glow-blue" style={{ width: '82%' }}></div>
                  </div>
                </div>
                <div className="mb-row">
                  <div className="mb-label">
                    <span>Millennials (25–34)</span>
                    <span className="mb-val">61%</span>
                  </div>
                  <div className="mb-track">
                    <div className="mb-fill glow-purple" style={{ width: '61%' }}></div>
                  </div>
                </div>
                <div className="mb-row">
                  <div className="mb-label">
                    <span>Gen X (35–44)</span>
                    <span className="mb-val">47%</span>
                  </div>
                  <div className="mb-track">
                    <div className="mb-fill glow-green" style={{ width: '47%' }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bc bc-text fu">
            <div>
              <div className="bc-label">Pricing Strategy</div>
              <h3>Find the optimal price point</h3>
              <p>
                Run price elasticity models. Find the number that maximises both volume and margin.
              </p>
            </div>
            <div className="bc-visual-demo bc-price-demo">
              <div className="price-sweet-label">Consumer sweet spot</div>
              <div className="price-value">&#8377;2,199</div>
              <div className="price-delta">&#8593; &#8377;400 above your initial target</div>
              <div className="price-range">
                <div className="price-range-track">
                  <div className="price-range-marker" style={{ left: '65%' }}></div>
                </div>
                <div className="price-range-labels">
                  <span>&#8377;999</span>
                  <span>&#8377;3,499</span>
                </div>
              </div>
            </div>
          </div>

          {/* Row 3: Campaign Testing */}
          <div className="bc bc-wide fu">
            <div className="bc-wide-content">
              <div className="bc-wide-left">
                <div className="bc-label">Campaign Testing</div>
                <h3>Test every creative before you spend a rupee on media.</h3>
                <p>
                  Drop in messaging, offers, and creative angles. Your simulated consumer society
                  tells you what wins.
                </p>
              </div>
              <div className="bc-wide-right">
                <div className="workflow">
                  <div className="wf-node">
                    <div className="wf-icon">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.5)" strokeWidth="2"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 002 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>
                    </div>
                    <div className="wf-label">Product</div>
                  </div>
                  <div className="wf-line"></div>
                  <div className="wf-node">
                    <div className="wf-icon">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.5)" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/></svg>
                    </div>
                    <div className="wf-label">Creatives</div>
                  </div>
                  <div className="wf-line"></div>
                  <div className="wf-node">
                    <div className="wf-icon">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.5)" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
                    </div>
                    <div className="wf-label">Society</div>
                  </div>
                  <div className="wf-line"></div>
                  <div className="wf-node">
                    <div className="wf-icon">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.5)" strokeWidth="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
                    </div>
                    <div className="wf-label">Results</div>
                  </div>
                  <div className="wf-line"></div>
                  <div className="wf-node wf-winner">
                    <div className="wf-icon">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#F26E38" strokeWidth="2"><path d="M20 6L9 17l-5-5"/></svg>
                    </div>
                    <div className="wf-label">Winner</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="hiw-section" id="how-it-works">
        <div className="fu">
          <div className="section-label">How it works</div>
          <h2 className="section-title">Three steps to consumer truth.</h2>
        </div>

        <div className="hiw-grid">
          {/* Step 1: Define */}
          <DefineCard />

          {/* Step 2: Simulate */}
          <div className="hiw-card hiw-card--violet fu">
            <div className="hiw-card-header">
              <div className="hiw-card-header-left">
                <div className="hiw-card-label" style={{ color: '#A78BFA' }}>SIMULATE</div>
                <div className="hiw-card-stage">STAGE_02</div>
              </div>
              <div className="hiw-card-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.6)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                </svg>
              </div>
            </div>
            <div className="hiw-card-body">
              <h3>Run the Simulation</h3>
              <p>Drop in your product, pricing, packaging, or campaign. Our AI consumer society reacts — browsing, buying, abandoning, sharing — exactly like real people.</p>
            </div>
            <div className="hiw-card-demo">
              <div className="hiw-demo-metrics">
                <div className="hiw-metric-row">
                  <span className="hiw-metric-label">Purchase Intent</span>
                  <span className="hiw-metric-val">82%</span>
                </div>
                <div className="hiw-metric-track"><div className="hiw-metric-fill" style={{ width: '82%', background: '#60A5FA' }}></div></div>
                <div className="hiw-metric-row">
                  <span className="hiw-metric-label">Brand Recall</span>
                  <span className="hiw-metric-val">74%</span>
                </div>
                <div className="hiw-metric-track"><div className="hiw-metric-fill" style={{ width: '74%', background: '#A78BFA' }}></div></div>
                <div className="hiw-metric-row">
                  <span className="hiw-metric-label">Viral Potential</span>
                  <span className="hiw-metric-val">91%</span>
                </div>
                <div className="hiw-metric-track"><div className="hiw-metric-fill" style={{ width: '91%', background: '#4ADE80' }}></div></div>
              </div>
            </div>
            <div className="hiw-card-footer">
              <div className="hiw-dots">
                <span className="hiw-dot"></span>
                <span className="hiw-dot active purple"></span>
                <span className="hiw-dot"></span>
              </div>
            </div>
          </div>

          {/* Step 3: Insights */}
          <div className="hiw-card hiw-card--green fu">
            <div className="hiw-card-header">
              <div className="hiw-card-header-left">
                <div className="hiw-card-label" style={{ color: '#4ADE80' }}>INSIGHTS</div>
                <div className="hiw-card-stage">STAGE_03</div>
              </div>
              <div className="hiw-card-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.6)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/>
                </svg>
              </div>
            </div>
            <div className="hiw-card-body">
              <h3>Act on the Insights</h3>
              <p>Get purchase intent, segment breakdowns, price elasticity, churn signals, and viral potential. Ship only what your consumers actually want.</p>
            </div>
            <div className="hiw-card-demo">
              <div className="hiw-demo-terminal">
                <div className="hiw-term-dots">
                  <span style={{ background: '#EF4444' }}></span>
                  <span style={{ background: '#EAB308' }}></span>
                  <span style={{ background: '#22C55E' }}></span>
                </div>
                <div className="hiw-term-line wide"></div>
                <div className="hiw-term-line accent"></div>
                <div className="hiw-term-line medium"></div>
                <div className="hiw-term-line short"></div>
                <div className="hiw-term-status">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4ADE80" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/></svg>
                  <span>GENERATING REPORT...</span>
                </div>
              </div>
            </div>
            <div className="hiw-card-footer">
              <div className="hiw-dots">
                <span className="hiw-dot"></span>
                <span className="hiw-dot"></span>
                <span className="hiw-dot active green"></span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="faq-section" id="faq">
        <div className="fu">
          <div className="section-label">FAQ</div>
          <h2 className="section-title" style={{ fontSize: 'clamp(26px,3vw,40px)' }}>
            Probably on<br />your mind.
          </h2>
        </div>
        <div className="faq-list">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`faq-item ${openFaqIndex === index ? 'open' : ''}`}
              onClick={() => toggleFaq(index)}
            >
              <div className="faq-q">
                {item.q} <span className="faq-icon">+</span>
              </div>
              <div className="faq-a">{item.a}</div>
            </div>
          ))}
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="cta-section">
        <div className="fu">
          <h2>
            Stop guessing.<br />
            <span className="orange">Start simulating.</span>
          </h2>
          <p className="cta-sub">
            Be the visionary, not the cautionary tale.
          </p>
        </div>
        <div className="fu">
          <div className="waitlist-row" id="waitlist-footer">
            <input
              id="email-footer"
              type="email"
              value={emailFooter}
              onChange={(e) => setEmailFooter(e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, 'footer')}
              placeholder="you@yourbrand.com"
              disabled={successFooter}
            />
            <button className="btn-orange" onClick={() => openModal(emailFooter)}>
              Get Early Access
            </button>
          </div>
          {successFooter && (
            <div className="success-msg">
              ✓ You're on the list — we'll be in touch soon.
            </div>
          )}
          <button className="btn-team" onClick={() => { setTeamSuccess(false); setTeamName(''); setTeamLinkedIn(''); setTeamPhone(''); setShowTeamModal(true); }}>
            Join the Team
          </button>
        </div>
      </section>

      {/* FOOTER */}
      <footer>
        <div className="footer-logo">SocietyX</div>
        <div className="footer-copy">© 2025 SocietyX. All rights reserved.</div>
        <button className="btn-team" onClick={() => { setTeamSuccess(false); setTeamName(''); setTeamLinkedIn(''); setTeamPhone(''); setShowTeamModal(true); }}>
          Join the Team
        </button>
      </footer>

      {/* TEAM MODAL */}
      {showTeamModal && (
        <div className="modal-overlay" onClick={() => setShowTeamModal(false)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowTeamModal(false)}>×</button>
            {teamSuccess ? (
              <div className="modal-success">
                <div className="modal-success-icon">✓</div>
                <h2>Application received!</h2>
                <p>We'll review your profile and reach out if there's a fit.</p>
              </div>
            ) : (
              <>
                <h2>Join the Team</h2>
                <p className="modal-sub">We're building something ambitious. Come help us build it.</p>
                <div className="modal-field">
                  <label>Full Name <span className="modal-required">*</span></label>
                  <input type="text" value={teamName} onChange={e => setTeamName(e.target.value)} placeholder="Your name" />
                </div>
                <div className="modal-field">
                  <label>LinkedIn Profile <span className="modal-required">*</span></label>
                  <input type="url" value={teamLinkedIn} onChange={e => setTeamLinkedIn(e.target.value)} placeholder="linkedin.com/in/yourprofile" />
                </div>
                <div className="modal-field">
                  <label>Contact Number</label>
                  <input type="tel" value={teamPhone} onChange={e => setTeamPhone(e.target.value)} placeholder="+91 98765 43210" />
                </div>
                <button className="btn-orange modal-submit" onClick={handleTeamSubmit} disabled={teamSubmitting}>
                  {teamSubmitting ? 'Submitting...' : 'Apply Now'}
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {/* WAITLIST MODAL */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
            {modalSuccess ? (
              <div className="modal-success">
                <div className="modal-success-icon">✓</div>
                <h2>You're on the list!</h2>
                <p>We'll reach out personally when we're ready to onboard your team.</p>
              </div>
            ) : (
              <>
                <h2>Join the waitlist</h2>
                <p className="modal-sub">Be the first to know when we're live.</p>
                <div className="modal-field">
                  <label>Name</label>
                  <input type="text" value={modalName} onChange={e => setModalName(e.target.value)} placeholder="Your name" />
                </div>
                <div className="modal-field">
                  <label>Company Email <span className="modal-required">*</span></label>
                  <input type="email" value={modalEmail} onChange={e => setModalEmail(e.target.value)} placeholder="you@example.com" />
                </div>
                <div className="modal-field">
                  <label>What decisions would you like Artificial Societies to help inform?</label>
                  <textarea value={modalProblem} onChange={e => setModalProblem(e.target.value)} placeholder="Tell us what you're looking for..." rows={4} />
                </div>
                <button className="btn-orange modal-submit" onClick={handleModalSubmit} disabled={modalSubmitting}>{modalSubmitting ? 'Submitting...' : 'Join Waitlist'}</button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingPage;
